import React, { Component } from 'react';
import { Link } from "react-router-dom";

import axios from 'axios'

import './About.css';

const FormOption = ({ id, val, selected, selectAction }) => (
  <li><input type="checkbox" name={val} id={id} value={id} checked={selected} onChange={selectAction}/><label for={id}>{val}</label></li>
 )

export class About extends Component {

  constructor(props) {
    super(props);

    this.state = { options: [] }
  }
  componentDidMount() {
    axios.get("/about-options.json")
    .then(res => {
      const options = res.data.map((o) => {
        return { key: o, selected: false }
      })

      this.setState({ options: options })
    })
    .catch(err => {
      console.log(err)
    })
  }

  selectOption = (e) => {
    const option = e.target.id.split('-').join(' ')
    const options = this.state.options.map((o) => {
      if (o.key === option) {
        return { ...o, selected: !o.selected}
      } else {
        return o
      }
    })
    this.setState({ options })
  }

  render() {

    const options = this.state.options.map((o) => {
      const oid = o.key.split(" ").join("-")
      return <FormOption id={oid} val={o.key} selected={o.selected} selectAction={this.selectOption} />
    });

    const selectedCount = this.state.options.reduce((a, o) => {
      return o.selected ? a + 1 : a;
    }, 0)

    return (
      <div className="cover-container presented">
        <Link className="about-link on-white" to={"/"} style={{color: "Black"}}>Back to projects</Link>
        <h1 className="content-title">Contact</h1>
        <div style={{width: "60%"}}>
          <p className="content-copy">We’re a small team, so we’ll always make sure we get back to you quickly. Fill out the relevent infomation bellow, so we can get to know you a bit better.</p>
          <form action="https://formspree.io/steffan.g.levet@gmail.com" method="POST" >
          <label>Name<span>Required</span></label>
          <input type="text" name="name" placeholder="Frank Loyd Wright"/>
          <label>Email address<span>Required</span></label>
          <input type="text" name="email" placeholder="contact@me.com"/>
          <label>Contact number<span>Required</span></label>
          <input type="text" name="phone" placeholder="+(64) 021 123 4567"/>
          <label>I'm getting in contact about<span>{selectedCount} selected</span></label>
          <div>
            <ul className="cboxtags">
              {options}
            </ul>
          </div>
          <label>Additional information</label>
          <textarea name="info"></textarea>
          <input type = "submit" value = "Send Enquiry" />
          </form>
        </div>
       </div>
    )
  }
}